import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { PopUpContextType, PopupContext } from '../../../../../_core/contexts/popToast';

interface PreferenceProps {
  value: boolean
  onChange: (_: boolean) => void
  className?: string
  prefTitle?: string
  otherTitle?: string
  lineBreak?: boolean
}

export const ByPreferenceFilter = (props: PreferenceProps) => {
  const { openPopup } = React.useContext<PopUpContextType>(PopupContext)
  const [preferenceState, setPreferenceState] = useState<boolean>(localStorage.getItem('likes-pref-toggled') === null)

  const togglePreference = () => {
    setPreferenceState(preferenceState => {
      const newValue = !preferenceState
      newValue ? localStorage.removeItem('likes-pref-toggled') : localStorage.setItem('likes-pref-toggled','false')
      return newValue
    })

    openPopup({
      'severity': 'info',
      'title': ' ',
      'text': props.value ? 'All likes are now showing.' : 'Likes are now being filtered based on your preferences.',
      'duration': 3500,
    })
    props.onChange(!props.value)
  }

  return (
    <div className={props.className || 'flex'}>
      <div className='d-flex align-items-center justify-content-between p-2'>
        {props.value ? (
          <h3 className='fs-4 fw-medium'>Matching Preferences</h3>
        ) : (
          <h3 className='fs-4 fw-medium mb-0'>All Likes</h3>
        )}
        {props.lineBreak ? (<br />) : <></>}
        <InputSwitch
          className='text-gray'
          checked={props.value}
          onClick={() => togglePreference()}
          tooltipOptions={{ position: 'top' }}
        ></InputSwitch>
      </div>
    </div>
  )
}

export default ByPreferenceFilter
